import * as angular from "angular";
import {$bringozFactory} from "../persistence-layer/bringoz-factory.factory";
import {BringozApi} from "../persistence-layer/models/bringoz-api.model";

angular
  .module('bringoz.admin.site-preferences')
  .factory('$preferences', PreferencesObjectFactory);

/* @ngInject */
function PreferencesObjectFactory($bringozFactory: $bringozFactory,
                                  PreferencesAPI: BringozApi) {
  function $preferences(id: string) {
    return $bringozFactory(id, PreferencesAPI);
  }

  return $preferences;
}
